export default "__VITE_ASSET__D542ZOXU__"